import * as React from 'react';

export default function P2pLineIcon({
  width = '24',
  height = '24',
  fill,
  className,
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={width}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_25430_175740)">
        <path
          d="M7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17Z"
          fill={fill}
        />
        <path
          d="M1.09961 18.9004H8.90039V16.5996H1.09961V18.9004ZM2.25 16.9004C2.71944 16.9004 3.09961 17.2806 3.09961 17.75C3.09961 18.2194 2.71944 18.5996 2.25 18.5996C1.78056 18.5996 1.40039 18.2194 1.40039 17.75C1.40039 17.2806 1.78056 16.9004 2.25 16.9004ZM7.75 16.9004C8.21943 16.9004 8.59961 17.2806 8.59961 17.75C8.59961 18.2194 8.21943 18.5996 7.75 18.5996C7.28057 18.5996 6.90039 18.2194 6.90039 17.75C6.90039 17.2806 7.28057 16.9004 7.75 16.9004ZM1.23926 15.4004H8.76074L7.77539 13.0996H2.22461L1.23926 15.4004ZM10.0996 20.5C10.0996 20.8314 9.83138 21.0996 9.5 21.0996H9C8.66862 21.0996 8.40039 20.8314 8.40039 20.5V20.0996H1.59961V20.5C1.59961 20.8314 1.33137 21.0996 1 21.0996H0.5C0.168633 21.0996 -0.0996094 20.8314 -0.0996094 20.5V15.4795L-0.0917969 15.4609L1.14844 12.5664C1.32181 12.1622 1.71934 11.9005 2.15918 11.9004H7.84082C8.28069 11.9005 8.67817 12.1622 8.85156 12.5664L10.0918 15.4609L10.0996 15.4795V20.5Z"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M14.0996 9.90039H21.9004V7.59961H14.0996V9.90039ZM15.25 7.90039C15.7194 7.90039 16.0996 8.28057 16.0996 8.75C16.0996 9.21943 15.7194 9.59961 15.25 9.59961C14.7806 9.59961 14.4004 9.21943 14.4004 8.75C14.4004 8.28057 14.7806 7.90039 15.25 7.90039ZM20.75 7.90039C21.2194 7.90039 21.5996 8.28057 21.5996 8.75C21.5996 9.21943 21.2194 9.59961 20.75 9.59961C20.2806 9.59961 19.9004 9.21943 19.9004 8.75C19.9004 8.28057 20.2806 7.90039 20.75 7.90039ZM14.2393 6.40039H21.7607L20.7754 4.09961H15.2246L14.2393 6.40039ZM23.0996 11.5C23.0996 11.8314 22.8314 12.0996 22.5 12.0996H22C21.6686 12.0996 21.4004 11.8314 21.4004 11.5V11.0996H14.5996V11.5C14.5996 11.8314 14.3314 12.0996 14 12.0996H13.5C13.1686 12.0996 12.9004 11.8314 12.9004 11.5V6.47949L12.9082 6.46094L14.1484 3.56641C14.3218 3.16217 14.7193 2.90048 15.1592 2.90039H20.8408C21.2807 2.90048 21.6782 3.16218 21.8516 3.56641L23.0918 6.46094L23.0996 6.47949V11.5Z"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_25430_175740">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
